module.exports = __webpack_public_path__ + "media/images/favicons/ms-icon-150x150-7c80b523939f1bdf953f48f410bbc541.png";